<template>
  <div>
    <button @click="toggleAnswer('yes')">Yes</button>
    <button @click="toggleAnswer('no')">No</button>
  </div>
</template>

<script>
import QuestionMixin from './QuestionMixin';

export default {
  name: 'yes-no',
  mixins: [QuestionMixin],

  methods: {
    toggleAnswer(ansVal) {
      if (
        this.answer !== undefined &&
        this.answer !== null &&
        this.answer !== '' &&
        this.answer === ansVal
      ) {
        this.setAnswer(null);
      } else {
        this.setAnswer(ansVal);
      }
    },
  },
};
</script>
